/**
 * 群管理页懒加载壳（14.26b；GroupSettingsLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function GroupManageLazy({ groupId }: { groupId: number }) {
  const { mod } = useLazyModule(() => import('./GroupManagePage'));
  if (mod === null) return <div data-testid="group-manage-loading-shell">加载中…</div>;
  return <mod.GroupManagePage groupId={groupId} />;
}
